export default "__VITE_PUBLIC_ASSET__13da1f25__"